import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { NgxPaginationModule } from 'ngx-pagination';

import { PaginaErrorComponent } from './components/pagina-error/pagina-error.component';
import { AlertaComponent } from './components/alerta/alerta.component';
import { SpinnerComponent } from './components/spinner/spinner.component';

import { AlertaService } from './components/alerta/alerta.service';
import { SpinnerService } from './components/spinner/spinner.service';
import { AutenticacionService } from './services/autenticacion.service';
import { ReCaptchaService } from './services/re-captcha.service';
import { ReCaptchaResolver } from './services/re-captcha-resolver.service';

import { NoCopyPasteDirective } from './directives/no-copy-paste.directive';

@NgModule({
  declarations: [
    PaginaErrorComponent,
    AlertaComponent,
    SpinnerComponent,
    NoCopyPasteDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule
  ],
  exports: [
    TranslateModule,
    NgxPaginationModule,
    PaginaErrorComponent,
    AlertaComponent,
    SpinnerComponent,
    NoCopyPasteDirective
  ],
  providers: [
    AlertaService,
    SpinnerService,
    AutenticacionService,
    ReCaptchaService,
    ReCaptchaResolver,
    { provide: 'LOCAL_STORAGE', useFactory: getLocalStorage }
  ],
})
export class SharedModule { }

export function getLocalStorage() {
  return (typeof window !== "undefined") ? window.localStorage : null;
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/shared/shared.module.ts